/**
 * Lotese Module Routes — granular permissions
 *
 * FASE 3d (2026-04-21): cada rota agora exige a permissão granular da sua
 * sub-página (ex: /lotese/conciliacao precisa de lotese_conciliacao:view).
 * A permissão antiga `lotese:read` foi deprecada mas continua no DB por
 * segurança — nenhum código do frontend/backend consulta ela mais.
 *
 * Ver docs do mapeamento em `docs/MODULO_LOTESE/` e seed em
 * `V1/backend/app/db/seeds/lotese_granular_permissions_seed.py`.
 */

import { lazy } from "react";
import { ModuleRoutes } from "../types";

const DashboardPage = lazy(() => import("@/pages/lotese/DashboardPage"));
const PontosGesPage = lazy(() => import("@/pages/lotese/PontosGesPage"));
const ConfiguracoesPage = lazy(() => import("@/pages/lotese/ConfiguracoesPage"));
const ComprovantesPage = lazy(() => import("@/pages/lotese/ComprovantesPage"));
const ExtratosPage = lazy(() => import("@/pages/lotese/ExtratosPage"));
const ConciliacaoPage = lazy(() => import("@/pages/lotese/ConciliacaoPage"));
const ConferenciaPage = lazy(() => import("@/pages/lotese/ConferenciaPage"));
const BaixasPage = lazy(() => import("@/pages/lotese/BaixasPage"));
const ColetasExternasPage = lazy(() => import("@/pages/lotese/ColetasExternasPage"));
const RelatoriosPage = lazy(() => import("@/pages/lotese/RelatoriosPage"));

export const loteseRoutes: ModuleRoutes = {
  moduleId: "lotese",
  basePath: "/lotese",
  routes: [
    {
      path: "/lotese",
      element: <DashboardPage />,
      permission: { resource: "lotese_dashboard", action: "view" },
    },
    {
      path: "/lotese/pontos",
      element: <PontosGesPage />,
      permission: { resource: "lotese_pontos", action: "view" },
    },
    {
      path: "/lotese/comprovantes",
      element: <ComprovantesPage />,
      permission: { resource: "lotese_comprovantes", action: "view" },
    },
    {
      path: "/lotese/extratos",
      element: <ExtratosPage />,
      permission: { resource: "lotese_extratos", action: "view" },
    },
    {
      path: "/lotese/conferencia",
      element: <ConferenciaPage />,
      permission: { resource: "lotese_conferencia", action: "view" },
    },
    {
      path: "/lotese/conciliacao",
      element: <ConciliacaoPage />,
      permission: { resource: "lotese_conciliacao", action: "view" },
    },
    {
      path: "/lotese/baixas",
      element: <BaixasPage />,
      permission: { resource: "lotese_baixas", action: "view" },
    },
    {
      // AUT-2 — mesma permissão das baixas de propósito: é a mesma pergunta
      // ("o que foi coletado"), só que pelo lado do que veio de fora.
      path: "/lotese/coletas-externas",
      element: <ColetasExternasPage />,
      permission: { resource: "lotese_baixas", action: "view" },
    },
    {
      path: "/lotese/relatorios",
      element: <RelatoriosPage />,
      permission: { resource: "lotese_relatorios", action: "view" },
    },
    {
      path: "/lotese/configuracoes",
      element: <ConfiguracoesPage />,
      permission: { resource: "lotese_config", action: "view" },
    },
  ],
};
